import { Modal } from 'antd';
import CollectionDetail from 'pages/Collection/CollectionDetail/CollectionDetail';
import React from 'react';
import { CollectionSelectedType } from './CollectionSelect';

export type CollectionSearchModalProps =  {
  colidp:number;
  visible: boolean;
  onCancel: () => void;
  setCollection?: (
    Collection: CollectionSelectedType
  ) => void;
};

const CollectionSearchModal = ({
  onCancel,
  visible,
  setCollection,
  colidp
}: CollectionSearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1600} destroyOnClose>
      <CollectionDetail colidp={colidp}/>
    </Modal>
  );
};

export default CollectionSearchModal;
